import apiClient from "@/app/api/client";
import { endpoints } from "@/shared/api/endpoints";

export type BackendRoomsReport = {
	total: number;
	sold: number;
	available: number;
	reserved: number;
	byFloor: Array<{
		floor: number;
		total: number;
		sold: number;
		available: number;
	}>;
	byRoomsCount: Array<{
		roomsCount: number;
		total: number;
		sold: number;
	}>;
};

export type RoomsReportParams = {
	buildingId?: string;
	blockId?: string;
};

export type RoomsReportData = {
	total: number;
	sold: number;
	available: number;
	reserved: number;
	free: number;
	floors: Array<{
		floor: number;
		total: number;
		sold: number;
	}>;
	byType: Array<{
		label: string;
		total: number;
		sold: number;
	}>;
};

export async function getRoomsReport(params?: RoomsReportParams): Promise<RoomsReportData> {
	const apiParams: Record<string, string> = {};
	if (params?.buildingId) {
		apiParams.buildingId = params.buildingId;
	}
	if (params?.blockId && params.blockId !== "all") {
		apiParams.blockId = params.blockId;
	}

	const response = await apiClient.get<{ success: boolean; data: BackendRoomsReport }>(
		endpoints.reports.rooms,
		{ params: apiParams }
	);

	const data = response.data.data;

	return {
		total: data.total ?? 0,
		sold: data.sold ?? 0,
		available: data.available ?? 0,
		reserved: data.reserved ?? 0,
		free: data.available ?? 0,
		floors: (data.byFloor || []).map((f) => ({
			floor: f.floor,
			total: f.total,
			sold: f.sold,
		})),
		byType: (data.byRoomsCount || []).map((r) => ({
			label: `${r.roomsCount}-xonali`,
			total: r.total,
			sold: r.sold,
		})),
	};
}
